<template>
  <p>When submitting images, please follow these guidelines:</p>
  <ul>
    <li>Images must be in JPG, JPEG, PNG, GIF, TIF, TIFF, or HEIC format.</li>
    <li>File size must be 5 MB or less.</li>
    <li>Image must be at least 100 pixels tall.</li>
    <li>Image must be at least 100 pixels wide.</li>
    <li>If you are not the copyright holder, you may not submit copyrighted images.</li>
    <li>Objectionable images will be rejected.</li>
    <li>Uploaded images become the property of the Company.</li>
  </ul>
</template>
